import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '#src/contexts/sport/index.ts';
import { useQuery } from '#src/hooks/graphql/useQuery.ts';
import { joinFiltersWithAnd, toFilterLiteral } from '#src/lib/algolia.ts';

import type {
  FootballCardsInLineupQuery,
  FootballCardsInLineupQueryVariables,
} from './__generated__/useNotInLineupFilterValue.graphql.ts';

const FOOTBALL_QUERY = gql`
  query FootballCardsInLineupQuery($sport: Sport!) {
    currentUser {
      slug
      blockchainCardsInLineups(sport: $sport)
    }
  }
` as TypedDocumentNode<
  FootballCardsInLineupQuery,
  FootballCardsInLineupQueryVariables
>;

const toFilter = (slugs: string[] | undefined | null) => {
  if (!slugs?.length) return undefined;

  return `(${joinFiltersWithAnd(
    slugs.map(objectID => `NOT slug:"${toFilterLiteral(objectID)}"`)
  )}) AND NOT rarity:common`;
};

export const useNotInLineupFilterValue = ({ skip }: { skip: boolean }) => {
  const { sport } = useSportContext();
  const { data, loading } = useQuery(FOOTBALL_QUERY, {
    skip,
    variables: { sport },
  });

  return {
    notInLineupFilterValue: toFilter(
      data?.currentUser?.blockchainCardsInLineups
    ),
    loading: !skip && loading && !data,
  };
};
